import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

const Loader = ({ isLoading }) => (
  <Backdrop
    sx={{ color: "#0891dc", zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={isLoading ? isLoading : false}
  >
    
    <CircularProgress color="inherit" size={50} />
  </Backdrop>
);
export default Loader;
